import React from "react";
import "./WitEarnPageWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

const WitEarnPageWrapper = ({ children }) => {
    return (
        <div className="WitEarnPageWrapper">
            <Navbar />
            {children}
            <Footer />
        </div>
    )
}
export default WitEarnPageWrapper